import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderCancelAndRefundUsingVoucher,
  orderEligibilitiesMockEligibleToRefundTypeInvoluntaryUsingVoucher,
  orderEligibilitiesMockEligibleToRefundUsingVoucher,
  orderMockEligibleToRefundUsingVoucher,
} from '../../../mock/data/index';

/**
 * Mocks for refundable order using Voucher and refund type voluntary.
 */
export const eligibleToRefundUsingVoucherMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingVoucher)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundUsingVoucher)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingVoucher)]
};

/**
 * Mocks for refundable order using Voucher and refund type involuntary.
 */
export const eligibleToRefundUsingVoucherRefundtypeInvoluntaryMock: MockMap = {
  retrieveOrder: [createMockData(orderMockEligibleToRefundUsingVoucher)],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundTypeInvoluntaryUsingVoucher)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundUsingVoucher)]
};
